(function () {
    var templateUrl = require('./search-results.html');
    require('../search-result-news/search-result-news.directive');
    require('../search-result-event/search-result-event.directive');
    require('../search-result-page/search-result-page.directive');
    require('../search-result-post/search-result-post.directive');

    angular.module('far.search').directive('searchResults', searchResults);

    function searchResults() {
        return {
            restrict: 'A',
            // replace: true,
            templateUrl: templateUrl,
            scope: {
                items: '=',
                showMore: '=',
                total: '=',
                hasNextResult: '='
            },
            controller: controller
        };

        function controller($scope) {
            $scope.hasNextResult = hasNextResult;

            function hasNextResult() {
                console.log($scope);
                return $scope.total > $scope.items.length;
            }
        }
    }
})();
